__webpack_require__.p = "https://ux-pool.azurewebsites.net/";